import crud from '@/crud/form/form'
import resources from '../../resources'
import methods from './methods'
import mounted from './mounted'
import validations from './validations'
import components from './components'

export default {
  methods,
  mounted,
  validations,
  components,
  resourcePath: '/v1/dweller/access',
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/form/resources/index.js